import { runDemo } from "../shared/demoRunner";
import { createRefProbeScene } from "./scene";

runDemo({ createScene: createRefProbeScene });
